<template>
  <div>
    <div class="table-wrapper origin-groups">
      <div>
        <b-button
          v-if="$can('create', 'origingroups', 'cdn')"
          variant="bg-primary"
          @click="onCreateGroupClick()"
        >
          <GjIcon
            class="icon-left"
            name="Plus"
          />
          Create Origin Group
        </b-button>
        <b-button
          v-if="$can('update', 'origingroups', 'cdn')"
          variant="bg-white"
          :disabled="!isGroupSelected"
          class="d-none d-lg-inline"
          @click="onEditGroupClick(groupSelected[0].originId)"
        >
          Edit
        </b-button>
        <button-loading
          v-if="$can('delete', 'origingroups', 'cdn')"
          variant="bg-white"
          :disabled="!isGroupSelected"
          :spinning="removingOriginGroup"
          class="d-none d-lg-inline"
          @click="onDeleteGroupClick(groupSelected[0].id)"
        >
          Delete
        </button-loading>
      </div>

      <!-- DESKTOP -->
      <div class="default-table position-relative d-none d-lg-block">
        <b-table
          ref="groupTable"
          :class="{ loaded: !fetchingOriginGroups }"
          :items="originGroups"
          :fields="originGroupsFields"
          :busy="fetchingOriginGroups"
          select-mode="single"
          show-empty
          selectable
          responsive
          @row-selected="onGroupRowSelected"
        >
          <template #cell(selected)="{ rowSelected }">
            <select-button :selected="rowSelected" />
          </template>

          <template #empty>
            <div
              v-if="fetchingOriginGroups"
              class="loading-table text-center py-3"
            >
              <b-spinner variant="primary" />
            </div>
            <template v-else>
              <no-data
                no-data-text="No origin groups have been added yet..."
                create-text="+ Create Origin Group"
                access-page="Origin Groups"
                :has-permissions="hasOriginGroupsPermissions"
                @action="onCreateGroupClick()"
              />
            </template>
          </template>
        </b-table>
      </div>
    </div>

    <!-- MOBILE -->
    <div class="position-relative d-lg-none">
      <div
        :class="{ 'opacity-7': fetchingOriginGroups || removingOriginGroup }"
      >
        <template v-for="origin in originGroups">
          <card
            :key="origin.id"
            :fields="originGroupsFields"
            :item="origin"
            class="top-fade-in"
          >
            <template #options>
              <b-dropdown
                id="dropdown-1"
                right
                variant="white"
              >
                <template #button-content>
                  <GjIcon name="Moreoptions" />
                </template>
                <b-dropdown-item
                  v-if="$can('update', 'origingroups', 'cdn')"
                  @click="onEditGroupClick(origin.originId)"
                >
                  Edit
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('delete', 'origingroups', 'cdn')"
                  @click="onDeleteGroupClick(origin.id)"
                >Delete</b-dropdown-item>
              </b-dropdown>
            </template>
          </card>
        </template>
      </div>
      <div
        v-if="fetchingOriginGroups || removingOriginGroup"
        class="mobile-loading"
      >
        <table-busy />
      </div>
      <template v-if="originGroups.length < 1">
        <div
          v-if="fetchingOriginGroups"
          class="empty-loading-table"
        />
        <paper-simple
          v-else
          class="top-fade-in"
        >
          <no-data
            class="text-center mb-4"
            no-data-text="No origin groups have been added yet..."
            create-text="+ Create Origin Group"
            access-page="Origin Groups"
            :has-permissions="hasOriginGroupsPermissions"
            @action="onCreateGroupClick()"
          />
        </paper-simple>
      </template>
    </div>
  </div>
</template>
<script>
import Card from '@/components/card/Card.vue'

export default {
  name: 'OriginGroups',
  components: {
    Card,
  },
  data() {
    return {
      id: null,
      originGroupsFields: [
        {
          key: 'selected',
          label: '',
          variant: 'select',
          hide: true,
        },
        { key: 'originId', isPrimary: true },
        { key: 'origins', isPrimary: true },
        'originRoutingType',
      ],
      hasOriginGroupsPermissions: true,
      groupSelected: [],
    }
  },
  computed: {
    originGroups() {
      return this.$store.state.cdn.origingroups
    },
    isGroupSelected() {
      return this.groupSelected[0]
    },
    removingOriginGroup() {
      return this.$store.state.cdn.removingOriginGroup
    },
    fetchingOriginGroups() {
      return this.$store.state.cdn.fetchingOriginGroups
    },
  },
  created() {
    this.id = this.$route.params.id
    this.dispatchOriginGroups()
  },
  methods: {
    dispatchOriginGroups() {
      this.$store.dispatch('cdn/fetchOriginGroups', this.id).catch(error => {
        if (error.response?.status === 403) {
          this.hasOriginGroupsPermissions = false
          return
        }
        this.errorToast(
          error.response?.data?.errors[0]
            || 'Something went wrong while fetching origin groups.',
        )
      })
    },
    onGroupRowSelected(item) {
      this.groupSelected = item
    },
    onCreateGroupClick() {
      this.$router.push({
        name: 'distribution-origin-groups-create',
        params: { id: this.id },
      })
    },
    onEditGroupClick(origingroupId) {
      this.$router.push({
        name: 'distribution-origin-groups-edit',
        params: { id: this.id, origingroupId },
      })
    },
    onDeleteGroupClick(originId) {
      this.confirmDelete(
        'Delete Origin Group',
        'Are you sure you want to delete this origin group?',
      ).then(ok => {
        if (ok) {
          this.$store
            .dispatch('cdn/removeOriginGroup', {
              distributionId: this.id,
              id: originId,
            })
            .then(() => {
              this.successToast('Origin group was removed')
              this.groupSelected = []
            })
            .catch(error => {
              this.errorToast(
                error.response?.data?.errors[0] || 'Something went wrong.',
              )
            })
        }
      })
    },
  },
}
</script>
